export const constants = {
  margin0: "0px",
  margin1: "1px",
  margin2: "2px",
  margin3: "3px",
  margin4: "4px",
  margin5: "5px",
  margin6: "6px",
  margin7: "7px",
  margin8: "8px",
  margin9: "9px",
  margin10: "10px",
  margin11: "11px",
  margin12: "12px",
  margin14: "14px",
  margin15: "15px",
  margin16: "16px",
  margin20: "20px",
  margin21: "21px",
  margin23: "23px",
  margin24: "24px",
  margin25: "25px",
  margin26: "26px",
  margin30: "30px",
  margin32: "32px",
  margin33: "33px",
  margin34: "34px",
  margin40: "40px",
  margin45: "45px",
  margin48: "48px",
  margin50: "50px",
  margin60: "60px",
  margin68: "68px",
  margin76: "76px",
  margin80: "80px",
  margin90: "90px",
  margin100: "100px",
  margin104: "104px",
  margin105: "105px",
  margin112: "112px",
  margin120: "120px",
  margin130: "130px",
  margin144: "144px",
  margin140: "140px",
  margin150: "150px",
  margin160: "160px",
  margin165: "165px",
  margin250: "250px",
  margin300: "300px",
  margin650: "650px",
  marginHalfem: "0.5em",
  margin1em: "1em",
  marginMinus10: "-10px",
  marginMinus14: "-14px",
  marginMinus20: "-20px",
  marginMinus47: "-47px",
  margin45PercentageImportant: "45% !important",
  margin50Percentage: "50%",
  margin90PercentageImportant: "90% !important",
  padding0: "0px",
  padding1: "1px",
  padding2: "2px",
  padding3: "3px",
  padding4: `4px`,
  padding5: "5px",
  padding6: "6px",
  padding7: "7px",
  padding8: "8px",
  padding10: "10px",
  padding12: "12px",
  padding14: "14px",
  padding15: "15px",
  padding19: "19px",
  padding20: "20px",
  padding24: `24px`,
  padding25: `25px`,
  padding27: `27px`,
  padding30: `30px`,
  padding35: "35px",
  padding37: `37px`,
  square39: "39px",
  padding40: `40px`,
  padding48: `48px`,
  padding50: "50px",
  padding100: "100px",
  padding125: "125px",
  padding150: "150px",
  font9: "9px",
  font10: "10px",
  font11: "11px",
  font12: "12px",
  font13: "13px",
  font14: `14px`,
  font16: `16px`,
  font18: `18px`,
  font20: `20px`,
  font21: `21px`,
  font23: `23px`,
  font24: `24px`,
  font28: `28px`,
  font30: `30px`,
  font32: `32px`,
  font36: `36px`,
  font40: `40px`,
  font48: `48px`,
  font60: `60px`,
  font69: `69px`,
  size16: `16px`,
  top5: "5px",
  top22: "22px",
  top56: "56px",
  top130: "130px",
  top137: "137px",
  top170: "170px",
  top172: "172px",
  top205: "205px",
  top280: "320px",
  bottom250: "250px",
  bottom270: "270px",
  topMinus45: "-45px",
  leftMinus13: "-13px",
  left0: "0px",
  left20: "20px",
  left26: "26px",
  left117: "117px",
  left141: "141px",
  left151: "151px",
  left160: "160px",
  left180: "180px",
  left190: "190px",
  left240: "240px",
  left266: "266px",
  left295: "295px",
  right38: "38px",
  right194: "194px",
  lineHeight0: "0px",
  lineHeight8: "8px",
  lineHeight12: "12px",
  lineHeight14: "14px",
  lineHeight16: "16px",
  lineHeight18: "18px",
  lineHeight20: `20px`,
  lineHeight22: `22px`,
  lineHeight24: `24px`,
  lineHeight30: `30px`,
  lineHeight32: `32px`,
  lineHeight35: `35px`,
  lineHeight40: `40px`,
  lineHeight42: `42px`,
  lineHeight52: `52px`,
  lineHeight64: `64px`,
  fontWeight100: "100",
  fontWeight200: "200",
  fontWeight300: "300",
  fontWeight350: "350",
  fontWeight400: "400",
  fontWeight500: "500",
  fontWeight600: "600",
  fontWeight700: "700",
  circleSize: "42px",
  maxHeight150: "150px",
  maxHeight200: "200px",
  maxHeight250: "250px",
  maxHeight300: "300px",
  maxHeight350: "350px",
  maxHeight450: "450px",
  scrollWidth: "30px",
  severityMinWidth: "95px",
  borderRadius2: "2px",
  borderRadius3: "3px",
  borderRadius4: "4px",
  borderRadius6: "6px",
  borderRadius10: "10px",
  borderRadius34: "34px",
  borderRadius50Percentage: "50%",
  borderRadius54: "54px",
  borderRadius100: "100px",
  width1: "1px",
  width5: "5px",
  width6: "6px",
  width7: "7px",
  width8: "8px",
  width9: "9px",
  width10: "10px",
  width11: "11px",
  width14: "14px",
  width15: "15px",
  width16: "16px",
  width19: "19px",
  width20: "20px",
  width24: "24px",
  width25: "25px",
  width26: "26px",
  width30: "30px",
  width32: "32px",
  width33: "33px",
  width38: "38px",
  width50: "50px",
  width57: "57px",
  width62: "62px",
  width72: "72px",
  width75: "75px",
  width77: "77px",
  width82: "82px",
  width83: "83px",
  width100: "100px",
  width112: "112px",
  width142: "142px",
  width150: "150px",
  width168: "168px",
  width207: "207px",
  width218: "218px",
  width240: "240px",
  width250: "250px",
  width255: "255px",
  width270: "270px",
  width300: "300px",
  width325: "325px",
  width336: "336px",
  width358: "358px",
  width385: "385px",
  width400: "400px",
  width445: "445px",
  width480: "480px",
  width510: "510px",
  width630: "630px",
  width600: "600px",
  width900: "900px",
  width910: "910px",
  width914: "914px",
  width915: "915px",
  width5Percentage: "5%",
  width22Percentage: "22%",
  width710: "710px",
  width41Percentage: "41%",
  width50Percentage: "50%",
  width51Percentage: "51%",
  width70Percentage: "70%",
  width95Percentage: "95%",
  width100Percentage: "100%",
  widthAuto: "Auto",
  roiPopupHeight: "554px",
  roiPopupChildHeight: "486px",
  paddingHalfEm: "0.5em",
  paddingOneAndQuarterEm: "1.25em",
  minHeight74: "74px",
  minHeight100: "100px",
  minHeight230: "230px",
  minHeight550: "550px",
  minHeight340: "340px",
  minHeight380: "380px",
  minHeight420: "420px",
  minHeight480: "480px",
  minHeight545: "545px",
  minHeight700: "700px",
  minHeight885: "885px",
  height0: "0px",
  height5: "5px",
  height8: "8px",
  height10: "10px",
  height12: "12px",
  height14: "14px",
  height16: "16px",
  height17: "17px",
  height18: "18px",
  height20: "20px",
  height24: "24px",
  height25: "25px",
  height26: "26px",
  height30: "30px",
  height31: "31px",
  height32: "32px",
  height34: "34px",
  height35: "35px",
  height36: "36px",
  height37: "37px",
  height40: "40px",
  height45: "45px",
  height48: "48px",
  height50: "50px",
  height52: "52px",
  height54: "54px",
  height55: "55px",
  height58: "58px",
  height59: "59px",
  height64: "64px",
  height69: "69px",
  height70: "70px",
  height80: "80px",
  height84: "84px",
  height86: "86px",
  height88: "88px",
  height124: "124px",
  height141: "141px",
  height173: "173px",
  height193: "193px",
  height220: "220px",
  height225: "225px",
  height300: "300px",
  height315: "315px",
  height350: "350px",
  height380: "380px",
  height405: "405px",
  height500: "500px",
  height580: "580px",
  height600: "600px",
  height850: "850px",
  height900: "900px",
  height100vh: "100vh",
  height100vhimportant: "100vh !important",
  height100Percentage: "100%",
  fontSize14: "14px",
  fontSize15: "15px",
  fontSize16: "16px",
  fontSize17: "17px",
  fontSize18: "18px",
  opacityPoint6: "0.6",
  opacityPoint8: "0.8",
  opacity1: "1",
  width100vw: "100vw",
  gap4rem: "4rem",
  gap5px: "5px",
  gap10px: "10px",
  gap20px: "20px",
  gap25px: "25px",
  gap20Percentage: "20%",
  width180: "180px",
  width290: "290px",
  height493: "493px",
  width159: "159px",
  padding9: "9px",
  padding11: "11px",
  top37: "37px",
  gap8 : "8px",
  width2 : "2px",
  width554 : "554px",
  height38 : "38px",
  width94 : "94px",
  lineHeight21: "21px",
  width310: "310px",
  padding38: "38px",
  top53: "53px",
  left61: "61px",
  width285: "285px",
  height437: "437px",
  height60vh: "60vh",
  width145:"145px",
  height110: "110px",
  width190:"190px",
  width440:"440px",
  width260:"260px",
  height202:"202px",
  padding65:"65px",
  height76:"76px",
  top178:"178px",
  height84vh: "84vh",
  width70vw: "70vw",
  height89vh: "89vh",
  width660:"660px",
  width1260:"1260px",
  width85: "85px",
  width96: "96px",
  width192: "192px",
  width185: "185px",
  width213: "213px",
  height126: "126px",
  width186: "186px"
};
